module.exports = __webpack_public_path__ + "static/images/components/VehicleType/images/lightTank-tiny.081524e0.png";


//////////////////
// WEBPACK FOOTER
// ./components/VehicleType/images/lightTank-tiny.png
// module id = 2723
// module chunks = 11